export const groupBy = <T>(items: T[], keyOf: (item: T) => string): Map<string, T[]> =>
  items.reduce((groups, item) => {
    const key = keyOf(item);
    const group = groups.get(key);
    if (group) {
      group.push(item);
    } else {
      groups.set(key, [item]);
    }
    return groups;
  }, new Map<string, T[]>());
